import { useQuery } from '@tanstack/react-query';

import { getCountries } from '@/infrastructure/network/data/lookups/countries';

export const useCountriesQuery = () => {
	return useQuery({
		queryKey: ['COUNTRIES'],
		queryFn: () => getCountries()
	});
};
